module.exports = __webpack_public_path__ + "501a24a4a1514c049bc1d690b096819d.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/skillset-banners/banner-review.png
// module id = 2976
// module chunks = 0